import TableWithTitle from "@/components/TableWithTitle.vue";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import { getDescriptionBasedOnKpiKey, getColorsBasedOnRange } from "@/utils/transformers";
import { capitalizeWords } from "@/utils";
import { SELECTOR, PERIOD_FIELD, MARKET_SIZE_FIELD, MARKET_UNITS_SOLD_FIELD, AVERAGE_PRICE_MARKET_FIELD, PRICE_RANGE_FIELD, AVERAGE_PRICE_SELLER_PERFORMANCE_FIELD, SHARE_OF_UNITS_SOLD_FIELD, MARKET_SHARE_FIELD, RANK_FIELD, RELATIVE_SHARE_VS_LEADER_FIELD, RELATIVE_SHARE_VS_PRECEDING_FIELD, BEST_BRAND_PRODUCT_RANK_FIELD, RATINGS_FIELD, REVIEWS_FIELD } from "@/utils/table_fields";
import AppIcon from "@/components/AppIcon.vue";
import { mapState } from "vuex";
import { HugValue, DateValue, RateChangeValue, CurrencyValue, NumberValue, BoxedValue, BarWithValue, PercentageValue, DottedValue, OverlapBarValue, EvolutionArrow, SegmentedBar, ImageElement, HashedNumberValue, DottedPositionBar, BarWithDifferenceFromMaxMarked, RangeBar, DotElement } from "@/components/tableElements";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import { DEFAULT_DATE_FORMATS, DAYS_INVENTORY_HEATMAP_COLORS, ORGANIC_CVR_HEATMAP_COLORS, BUYBOX_HEATMAP_COLORS, PERIOD_COLUMN_TITLES, COLORS } from "@/utils/constants";
import FlexRow from "@/components/FlexRow.vue";
import moment from "moment";
import { capitalize } from "vue";
import SlotWithEvolutionValue from "@/components/tableElements/SlotWithEvolutionValue.vue";
import EvolutionValue from "@/components/tableElements/EvolutionValue.vue";
import WrapTableWithShowMore from "@/components/WrapTableWithShowMore.vue";
import TextValue from "@/components/tableElements/TextValue.vue";
export default {
  name: "PeriodTable",
  components: {
    TableWithTitle,
    WrapWithPopover,
    AppIcon,
    HugValue,
    DateValue,
    RateChangeValue,
    CurrencyValue,
    NumberValue,
    BoxedValue,
    BarWithValue,
    PercentageValue,
    DottedValue,
    OverlapBarValue,
    FlexRow,
    SlotWithEvolutionValue,
    EvolutionValue,
    WrapTableWithShowMore,
    TextValue,
    EvolutionArrow,
    SegmentedBar,
    ImageElement,
    HashedNumberValue,
    DottedPositionBar,
    BarWithDifferenceFromMaxMarked,
    RangeBar,
    DotElement
  },
  mixins: [LiteTableMixin],
  props: {
    loading: {
      typ: Boolean,
      required: true
    }
  },
  emits: ["setDateRange", "refresh"],
  data() {
    return {
      DAYS_INVENTORY_HEATMAP_COLORS,
      ORGANIC_CVR_HEATMAP_COLORS,
      BUYBOX_HEATMAP_COLORS,
      PERIOD_COLUMN_TITLES,
      COLORS,
      fields: [SELECTOR, PERIOD_FIELD, RANK_FIELD, MARKET_SHARE_FIELD, SHARE_OF_UNITS_SOLD_FIELD, BEST_BRAND_PRODUCT_RANK_FIELD, MARKET_SIZE_FIELD, MARKET_UNITS_SOLD_FIELD, PRICE_RANGE_FIELD, RELATIVE_SHARE_VS_LEADER_FIELD],
      evolCategory: {
        prev_period: "_previous_period",
        same_period_ly: "_last_year"
      }
    };
  },
  computed: {
    ...mapState({
      periodTable: state => state.market_insights.periodTable,
      tab: state => state.market_insights.currentTabValue,
      period: state => state.market_insights.period,
      currentPeriod: state => state.market_insights.currentPeriod,
      periodCategory: state => state.market_insights.periodCategory
    }),
    items() {
      return this.periodTable[this.tab].items;
    },
    maxCharCount() {
      return this.periodTable[this.tab].maxCharCount;
    },
    minMax() {
      return this.periodTable[this.tab].minMax;
    },
    getDateValueFormat() {
      // Convert the current period to UPPER CASE
      const period = this.period.toUpperCase();
      return DEFAULT_DATE_FORMATS[period];
    },
    getPeriodColumnTitle() {
      return PERIOD_COLUMN_TITLES[this.period];
    },
    period_pager: {
      get() {
        return this.periodTable.period_page;
      },
      set(_) {
        this.$store.dispatch("marketInsightsIncrementPeriodPage");
        this.$emit("refresh");
      }
    }
  },
  methods: {
    getDescriptionBasedOnKpiKey,
    getColorsBasedOnRange,
    capitalizeWords,
    handleDateClick(period) {
      period = moment(period);
      this.$emit("setDateRange", period);
    },
    handleDateReset() {
      this.$emit("setDateRange", null);
    },
    handleRowClick(item) {
      this.handleRowClicked(item, this.handleDateReset, this.handleDateClick, "period_agg");
    }
  }
};